import {
    UPDATE_ALL_USER_LIST,
    CLEAR_NOTIFICATIONS
} from "@/store/actions.type"

import {
    UPDATE_FOLLOWER,
    UPDATE_FOLLOWING,
    UPDATE_LIKED_USER,
    UPDATE_SUGGESTED_USER,
    UPDATE_SEARCH_LIST,
    SET_NOTIFICATIONS
}
from "@/store/mutations.type"

export default {
    [UPDATE_ALL_USER_LIST]({ commit }, payload) {
        commit(UPDATE_FOLLOWER, {
            userId: payload.userId,
            value: payload.value
        })
        commit(UPDATE_FOLLOWING, {
            userId: payload.userId,
            value: payload.value
        })

        commit(UPDATE_LIKED_USER, {
            userId: payload.userId,
            value: payload.value
        })

        commit(UPDATE_SUGGESTED_USER, {
            userId: payload.userId,
            value: payload.value
        })

        commit(UPDATE_SEARCH_LIST, {
            itemId: payload.userId,
            value: payload.value
        })
    },

    [CLEAR_NOTIFICATIONS]({commit}) {
        commit(SET_NOTIFICATIONS, {
            message: null
        })
    }
}